import React, { Component, useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './NavMenu.css';
import { DarkMode } from '../DarkTheme';
import { packages, whatWeDo } from './MenuList';

export const NavMenu = () => {
    const [theme, setTheme] = useState(localStorage.getItem('theme'));
    const [scroll, setScroll] = useState(false);
    const [hamburger, setHamburger] = useState(false);
    const [menuToggle1, setMenuToggle1] = useState(false);
    const [menuToggle2, setMenuToggle2] = useState(false);



    const lightTheme = "light"

    if (localStorage.getItem('theme') === null) {
        localStorage.setItem('theme', 'light');
        document.body.classList.remove('dark', 'light');
        document.body.classList.add('light');
    }
    else {
        document.body.classList.remove('dark', 'light');
        document.body.classList.add(localStorage.getItem('theme'));
    }


    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 250);
        });
    }, []);

    const switchTheme = (e) => {
        let Theme = '';
        if (localStorage.getItem('theme') === 'light') {
            Theme = 'dark';
            document.body.classList.remove('dark', 'light');
            document.body.classList.add(Theme);
            localStorage.setItem('theme', Theme);
            setTheme(Theme)

        }
        else {
            Theme = 'light';
            document.body.classList.remove('dark', 'light');
            document.body.classList.add(Theme);
            localStorage.setItem('theme', Theme);
            setTheme(Theme);
        }
    }
    return (
        <header>
            <nav className={`navbar navbar-expand-lg p-0 ${scroll ? 'fixed' : ''}`}>
                <div className="container-fluid position-relative align-items-center">
                    <div>
                        <a className="navbar-brand" href="#"><img style={{ transform: 'rotate(352deg)' }} src={`${theme === lightTheme ? "./images/logo.png" : "./images/white-logo.png"}`} alt="Website Drona Logo" /></a>
                        <a className="navbar-brand" href="#"><img className='years15' src={`${theme === lightTheme ? "./images/15years.png" : "./images/15years-white.png"}`} style={{ width: '100px' }} alt="15 Years Of Experience" /></a>
                    </div>
                    <div className='d-flex d-lg-none align-items-center'>
                        <div className='me-3'>
                            <DarkMode switchTheme={switchTheme} theme={theme} lightTheme={lightTheme} />
                        </div>
                        <button className="navbar-toggler align-items-end d-flex flex-column lg-d-none" onClick={() => setHamburger(true)}>
                            <span className=""></span>
                            <span className="bar-2"></span>
                            <span className="bar-2"></span>
                        </button>
                    </div>
                    <div className={`collapse navbar-collapse justify-content-center align-items-start ${!hamburger ? '' : 'show'}`}>
                        <div className='d-flex d-lg-none justify-content-end'>
                            <i className="fa-solid fa-xmark float-end fs-1" type="button" onClick={() => setHamburger(false)} data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"></i>
                        </div>
                        <ul className="nav navbar-nav align-items-start align-items-lg-center gap-2">
                            <li><NavLink to="/" onClick={() => setHamburger(false)}>Home</NavLink></li>
                            <li><NavLink to="/who-we-are" onClick={() => setHamburger(false)}>Who we are</NavLink></li>
                            <li className="nav-item dropdown menu-area">
                                <a className="nav-link dropdown-toggle p-0" style={{ cursor: 'pointer' }} onClick={() => { if (window.innerWidth <= 1000) setMenuToggle1(!menuToggle1) }} >
                                    What we do
                                </a>
                                <div className={`dropdown-menu mega-area service-list m-0 border-top ${menuToggle1 ? 'show' : ''}`}>
                                    <div className="row bg-lg-white overflow-hidden mx-0 px-0">
                                        <div className="col-md-6 d-none d-lg-flex flex-column align-items-center mega-menu-col p-3 ">
                                            <img src='./images/header_svg.svg' alt="Website Drona" />
                                        </div>
                                        <div className="col-md-6 p-0 d-flex flex-column justify-content-center">
                                            <ul className='d-flex flex-wrap p-0 m-0 menu_list'>
                                                {whatWeDo.map((item, index) =>
                                                    <li key={index}>
                                                        <NavLink to={item.path} className="dropdown-item" onClick={() => setHamburger(false)}>{item.pageName}</NavLink>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item dropdown menu-area">
                                <a className="nav-link dropdown-toggle p-0" style={{ cursor: 'pointer' }} onClick={() => { if (window.innerWidth <= 1000) setMenuToggle2(!menuToggle2) }}>
                                    Packages
                                </a>
                                <div className={`dropdown-menu mega-area service-list m-0 border-top ${menuToggle2 ? 'show' : ''}`} >
                                    <div className="row bg-lg-white overflow-hidden mx-0 px-0 align-items-center">
                                        <div className="col-md-6 d-none d-lg-block mega-menu-col solution-col p-0">
                                            <img src='./images/header2.png' alt="Packages" />
                                        </div>
                                        <div className="col-md-6 p-0">
                                            <ul className='d-flex flex-wrap p-0 m-0 menu_list'>
                                                {packages.map((item, index) =>
                                                    <li key={index}>
                                                        <NavLink to={item.path} className="dropdown-item" onClick={() => setHamburger(false)}>{item.pageName}</NavLink>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li><NavLink to="/portfolio" onClick={() => setHamburger(false)}>Portfolio</NavLink></li>
                            <li><NavLink to="/contact-us" onClick={() => setHamburger(false)}>Contact us</NavLink></li>

                        </ul>
                        <ul className='d-flex align-items-center m-0 align-items-end top_side_links ms-5'>
                            <li><Link className="text-decoration-none drona-domain-btn btn py-0 d-flex align-items-center gap-2" to="https://domainsagar.com/" target="_blank"><div className='domain-btn'><img src='./images/globe.gif' alt='WWW Icon Representing Website Hosting With Domain Sagar'/></div>Buy Domain</Link></li>
                        </ul>
                    </div>
                    <div className='d-none d-lg-block'><DarkMode switchTheme={switchTheme} theme={theme} lightTheme={lightTheme} /></div>
                </div>
            </nav>
        </header>
    );
}
